import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledLabelWrapper = styled.div`
    min-width: 125px;
    margin-bottom: 4px;
`;

export const StyledIncludeExcludeWrapper = styled.div`
    margin-top: -8px;
`;

export const StyledLabelRow = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    padding: 0;
    margin-bottom: 20px;
`;

export const StyledMainSection = styled.div`
    padding: 8px 12px 16px 12px;
    user-select: none;
`;

export const StyledContainer = styled.div`
    background-color: ${colorsPalettes.carbon["0"]};
    margin-bottom: 4px;
    position: relative;
    border-radius: 2px;
    overflow: hidden;
`;
